/**
 * SEVA-tec Universal Megamenu Trigger - Multi-Language Version
 * Unterstützt alle 12+ Sprachen und Trigger-Elemente.
 */

(function() {
    'use strict';

    /**
     * Kern-Logik: Findet das Ziel-Menü-Element im Header völlig sprachneutral.
     */
    function findProdukteMenuItem() {
        // Sucht in den gängigen Menü-Selektoren deines Themes
        const menuItems = document.querySelectorAll('a.menu-lv-1__action, a.header__menu-item, .header__inline-menu a');
        
        for (const item of menuItems) {
            const href = item.getAttribute('href') || '';
            
            /**
             * Da der Text ("Produits", "Products", etc.) variiert, prüfen wir die URL.
             * Jede Sprachversion behält "/collections/all" im Pfad bei.
             */
            const isProductLink = (
                href.includes('/collections/all') || 
                href.endsWith('/produkte') || 
                href.endsWith('/products')
            );
            
            if (isProductLink) {
                console.log('Megamenu Ziel gefunden:', href);
                // Gibt das Eltern-Element zurück, das für die Anzeige zuständig ist
                return item.closest('.menu-lv-item') || item.closest('details') || item.parentElement;
            }
        }
        
        // Letzter Rettungsanker: Erstes Element mit Megamenü-Klasse
        return document.querySelector('.menu-lv-item.has-megamenu');
    }

    /**
     * Öffnet das Megamenü (Desktop & Mobile)
     */
    function openMegaMenu(menuItem) {
        if (!menuItem) return;

        if (window.innerWidth >= 1025) {
            // Desktop: CSS-Klassen und Styles setzen
            const dropdown = menuItem.querySelector('.menu-dropdown, .mega-menu, .header__submenu');
            
            if (dropdown) {
                menuItem.classList.add('is-open');
                
                // Setzt Styles direkt, falls das Theme nur auf :hover reagiert
                dropdown.style.display = 'block';
                dropdown.style.opacity = '1';
                dropdown.style.visibility = 'visible';
                dropdown.style.transform = 'translateY(0)';
                dropdown.style.pointerEvents = 'auto';
                
                // Schließen-Logik bei Klick außerhalb
                const closeHandler = (e) => {
                    if (!menuItem.contains(e.target)) {
                        menuItem.classList.remove('is-open');
                        dropdown.style.display = '';
                        dropdown.style.opacity = '';
                        dropdown.style.visibility = '';
                        dropdown.style.transform = '';
                        document.removeEventListener('click', closeHandler);
                    }
                };
                setTimeout(() => document.addEventListener('click', closeHandler), 100);
            }
        } else {
            // Mobile: Simuliert den Klick auf den Menü-Link
            const link = menuItem.querySelector('a') || menuItem;
            link.click();
        }
    }

    /**
     * Initialisiert alle 12+ Trigger (Buttons, Textlinks, Hash-Links)
     */
    function initTriggers() {
        // Selektoren für alle möglichen Trigger-Varianten
        const triggerSelector = [
            '.js-open-produkte-megamenu',
            'a[data-open-megamenu]',
            'a[href*="#megamenu"]',
            'a[href*="#products"]',
            'a[href*="/collections/all"]'
        ].join(', ');

        const triggers = document.querySelectorAll(triggerSelector);

        triggers.forEach(trigger => {
            if (trigger.hasAttribute('data-megamenu-initialized')) return;
            trigger.setAttribute('data-megamenu-initialized', 'true');
            
            trigger.addEventListener('click', function(e) {
                const href = this.getAttribute('href') || '';
                
                // Nur unterbrechen, wenn es ein Anker-Link innerhalb der Seite ist
                if (href.includes('#')) {
                    e.preventDefault();
                }
                e.stopPropagation();
                
                const target = findProdukteMenuItem();
                if (target) {
                    // Sanft nach oben scrollen für bessere Sichtbarkeit
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    
                    // Kurze Verzögerung für das Scroll-Event
                    setTimeout(() => openMegaMenu(target), 250);
                }
            });
        });
    }

    // Start-Logik
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTriggers);
    } else {
        initTriggers();
    }

    // Beobachtet den Shop auf nachgeladene Inhalte (Ajax/Sektionen)
    const observer = new MutationObserver(() => initTriggers());
    observer.observe(document.body, { childList: true, subtree: true });

    // Debug-Funktion für die Konsole
    window.testMegamenu = () => openMegaMenu(findProdukteMenuItem());

})();